export default "__VITE_ASSET__BLZOQSg___"